<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='700px' center
             :before-close="dialogClose" :close-on-click-modal="false">
    <el-form :model='uploadData' label-width='130px' label-position='right' :rules='rules'
             ref='ruleForm' class='mt20' v-loading='importLoading'>
      <el-form-item label='变更原因：' prop='reason'>
        <el-input v-model='uploadData.reason'  type="textarea" placeholder='请输入变更原因' />
      </el-form-item>
      <el-form-item label='委托车导入：' >
        <div class='exportButton' style='display: flex;justify-content: flex-start;'>
          <span @click='download'>模板下载</span>
          <el-upload
            ref="upload"
            :action="uploadUrl"
            show-file-list
            :data="uploadData"
            :multiple="false"
            :auto-upload="false"
            :before-upload="beforeUpload"
            :on-success="success"
          >
            <i  class='el-icon-upload el-icon--right'
                style=' color: rgba(51, 136, 255, 1);'>批量导入</i>
          </el-upload>
        </div>
      </el-form-item>
      <div class='flex-center-center mt20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submitClick'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>

import {getImportUrl} from "@/service/getIP";

export default {
  data() {
    return {
      dialogTitle: '',
      dialogVisible: false,
      submitLoading: false,
      form:{},
      importLoading:false,
      rules:{
        reason: [
          {
            required: true,
            message: '请输入变更原因',
            trigger: 'blur',
          },
        ],
      },
      result: '',
      type:'',
      uploadData:{
        id: '',
        mFile: '',//文件名
        bgType: '',
        reason: ''
      },
      uploadUrl: getImportUrl('/change/review/updateByFile')
    }
  },
  mounted() {
    this.defaultForm = JSON.parse(JSON.stringify(this.uploadData));
  },
  methods:{
    dialogOpen(row){
      this.uploadData = row
      if(row.bgType === 0){
        this.dialogTitle = '运输计划变更'
      }else {
        this.dialogTitle = '实际运输变更'
      }
      this.dialogVisible = true
    },
    //提交
    submitClick() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          this.$refs.upload.submit()
          this.dialogClose();
          this.submitLoading = false
        }
      })
    },
    //取消
    dialogClose(){
      this.dialogVisible = false
      this.uploadData = JSON.parse(JSON.stringify(this.defaultForm));
    },
    //模板下载
    download() {
      if(this.uploadData.bgType === 0){
        window.location.href =  '/file/运输计划变更模板.xlsx'
      }else {
        window.location.href = '/file/实际运输变更模板.xlsx';
      }
    },
    beforeUpload(file) {
      if (file.name.split('.')[1] === 'xlsx') {
        this.uploadData.mFile = file.name;
      } else {
        this.$message.error('请选择excel文件导入！！！');
        return false;
      }
    },
    success(response, file, fileList){
      if(response.status == -1 && response.message ==='操作成功'){
        this.$message.success(response.message);
      }else {
        this.$message.warning(response.message);
      }
      // 清空上传文件列表
      this.$refs.upload.clearFiles();
      this.$emit('searchBtn');
    }
  }
}
</script>


<style scoped lang="scss">

</style>
